import Registry from 'live/services/registry'

export type SidebarItem = {
    id: string
    label: string
    icon: React.ReactNode
    order: number
    href?: string
    onClick?: () => void
}

export const SidebarRegistry = new Registry<SidebarItem>()
